<div class="container-fluid">
    <div class="container-fluid client-list-container">
        <div class="row my-3">
            <div class="col">
                <div class="list-group list-group-horizontal">
                    <a href="/events/all"
                        class="list-group-item list-group-item-action {{currentStatus === undefined ? 'active' : ''}}">All</a>
                    <a href="/events/all?status=1"
                        class="list-group-item list-group-item-action {{currentStatus == 1 ? 'active' : ''}}">Pending</a>
                    <a href="/events/all?status=2"
                        class="list-group-item list-group-item-action {{currentStatus == 2 ? 'active' : ''}}">Approved</a>
                    <a href="/events/all?status=4"
                        class="list-group-item list-group-item-action {{currentStatus == 4 ? 'active' : ''}}">On
                        going</a>
                    <a href="/events/all?status=5"
                        class="list-group-item list-group-item-action {{currentStatus == 5 ? 'active' : ''}}">Finished</a>
                    <a href="/events/all?status=3"
                        class="list-group-item list-group-item-action {{currentStatus == 3 ? 'active' : ''}}">Cancelled</a>
                    <a href="/events/all?status=0"
                        class="list-group-item list-group-item-action {{currentStatus == 0 ? 'active' : ''}}">Deleted</a>
                </div>
            </div>
        </div>
        <div class="row">

            <div class="col">
                <div class="card">
                    <div class="card-header">
                        Events
                    </div>
                    <div class="card-body">
                        <div class="card mb-3" [hidden]="hideEditEventContainer" #updateEventContainer>
                            <div class="card-body" [hidden]="!hideEditBody">
                                <div class="d-flex justify-content-center">
                                    <div class="spinner-border" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body" id="editEventContainer" [hidden]="hideEditBody">
                                <div class="row">
                                    <div class="col-2">
                                        <div class="form-group">
                                            <label>Event Name</label>
                                            <input type="text" class="form-control form-control-sm"
                                                [(ngModel)]="eventToUpdate.eventName" />
                                        </div>
                                    </div>
                                    <div class="col-2">
                                        <div class="form-group">
                                            <label>Language</label>
                                            <select class="form-control form-control-sm"
                                                [(ngModel)]="eventToUpdate.language">
                                                <option *ngFor="let language of clientLanguageArray"
                                                    [value]="language.value">
                                                    {{language.label}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-2">
                                        <div class="form-group">
                                            <label>Village</label>
                                            <ng-select [items]="villageOptions" class="custom"
                                                [(ngModel)]="eventVillage"></ng-select>
                                        </div>
                                    </div>
                                    <div class="col text-right" style="padding-top: 15px;">
                                        <button type="button" class="btn btn-danger btn-sm"
                                            (click)="onEditCancelButtonClick()">Cancel</button>
                                        <button type="button" class="btn btn-primary btn-sm ml-1"
                                            (click)="onEditButtonClick()">Edit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <section class="events-list-container">
                            <app-data-table [columns]="columns" [loadPage]="loadPage" [(filters)]="filters"
                                [filtersComponent]="dataFilters" [pageSize]="20" (onReset)="onTableReset()" [tBodyTrAdditionalClass]="tBodyTrAdditionalClass">
                                <app-data-filters #dataFilters>
                                    <app-data-filter-group>
                                        <app-data-filter-input label="Id" [(model)]="filters.id" placeholder="Id">
                                        </app-data-filter-input>
                                        <app-data-filter-input label="Event Name" [(model)]="filters.eventName"
                                            placeholder="Event Name"></app-data-filter-input>
                                        <app-data-filter-input label="Customer Name" [(model)]="filters.customerName"
                                            placeholder="Customer Name">
                                        </app-data-filter-input>
                                        <app-data-filter-input label="Company Name" [(model)]="filters.company"
                                            placeholder="Company Name">
                                        </app-data-filter-input>
                                        <app-data-filter-datepicker label="Start Date" [(model)]="filters.startDate">
                                        </app-data-filter-datepicker>
                                        <app-data-filter-datepicker label="End Date" [(model)]="filters.endDate">
                                        </app-data-filter-datepicker>
                                        <app-data-filter-datepicker label="Pick up Date" [(model)]="filters.pickUpDate">
                                        </app-data-filter-datepicker>
                                        <app-data-filter-datepicker label="Return Date" [(model)]="filters.returnDate">
                                        </app-data-filter-datepicker>
                                    </app-data-filter-group>
                                </app-data-filters>
                            </app-data-table>
                        </section>

                        <ng-template #idColumn let-id="id">
                            {{id}}
                        </ng-template>

                        <ng-template #eventNameColumn let-eventName="eventName" let-id="id">
                            <a href="events/details/{{id}}" class="text-muted" style="text-decoration: underline"
                                (click)="onUpdateEventButtonClick(id, updateEventContainer)">{{eventName}} <i
                                    class="fa fa-pencil-alt"></i></a>
                        </ng-template>

                        <ng-template #startDateColumn let-startDate="startDate">
                            <strong>{{startDate | date:'dd-MM-yyyy'}}</strong>
                        </ng-template>

                        <ng-template #endDateColumn let-endDate="endDate">
                            <strong>{{endDate  | endDate:'DD-MM-YYYY'}}</strong>
                        </ng-template>

                        <ng-template #pickUpDateColumn let-pickUpDate="pickUpDate">
                            {{pickUpDate | date:'dd-MM-yyyy'}}
                        </ng-template>

                        <ng-template #returnDateColumn let-returnDate="returnDate">
                            {{returnDate | date:'dd-MM-yyyy'}}
                        </ng-template>

                        <ng-template #villageColumn let-village="village">
                            {{(village ? village.name : '')}}
                        </ng-template>

                        <!-- <ng-template #customerNameColumn let-clientUser="clientUser">
                            <span *ngIf="clientUser"> <a href="clients/edit/{{clientUser.id}}" class="text-muted"
                                    style="text-decoration: underline" target="_blank"><i class="fa fa-pencil-alt"></i>
                                    {{clientUser.firstName}} {{clientUser.lastName}} </a> </span>
                        </ng-template> -->

                        <ng-template #companyColumn let-company="clientUser.company">
                            <span *ngIf="company"><a href="companies/details/{{company.id}}" class="text-muted"
                                    style="text-decoration: underline" target="_blank"><i class="fa fa-info"></i>
                                    {{company.name}} </a></span>
                        </ng-template>

                        <ng-template #statusColumn let-status="status" let-startDate="startDate" let-endDate="endDate">
                            <span [outerHTML]="status | eventStatus:startDate:endDate"></span>
                        </ng-template>

                        <ng-template #onlineColumn let-onlineEvent="onlineEvent">
                            <ng-container *ngIf="!onlineEvent; else presentTemplate">
                              <i style="color: red; cursor: pointer;" class="fas fa-times"></i>
                            </ng-container>
                            <ng-template #presentTemplate>
                              <i style="color: green; cursor: pointer;" class="fas fa-check"></i>
                            </ng-template>
                        </ng-template>

                        <ng-template #hasDeviceUsersColumn let-requestedSoftwareTypes="requestedSoftwareTypes"
                            let-deviceUsers="deviceUsers">
                            <ng-container
                                *ngIf="checkRequestedDeviceUsersQuantity(requestedSoftwareTypes, deviceUsers); else noDeviceUsersTemplate">
                                <i style="color: green;" class="fas fa-check"></i>
                            </ng-container>
                            <ng-template #noDeviceUsersTemplate>
                                <i style="color: red;" class="fas fa-times"></i>
                            </ng-template>
                        </ng-template>

                        <ng-template #hasPriceListColumn let-priceLists="priceLists">
                            <ng-container *ngIf="priceLists?.length > 0; else noPriceListTemplate">
                                <strong style="color: green;">{{priceLists?.length}}</strong>
                            </ng-container>
                            <ng-template #noPriceListTemplate>
                                <i style="color: red;" class="fas fa-times"></i>
                            </ng-template>
                        </ng-template>

                        <ng-template #hasPrintersColumn let-requestedSoftwareTypes="requestedSoftwareTypes"
                            let-printers="printers">
                            <ng-container
                                *ngIf="checkRequestedPrinterQuantity(requestedSoftwareTypes, printers); else noPrintersTemplate">
                                <i style="color: green;" class="fas fa-check"></i>
                            </ng-container>
                            <ng-template #noPrintersTemplate>
                                <i style="color: red;" class="fas fa-times"></i>
                            </ng-template>
                        </ng-template>

                        <ng-template #hasRoutersColumn let-requestedRouterTypes="requestedRouterTypes"
                            let-routers="routers">
                            <ng-container
                                *ngIf="checkRequestedRouterQuantity(requestedRouterTypes, routers); else noRoutersTemplate">
                                <i style="color: green;" class="fas fa-check"></i>
                            </ng-container>
                            <ng-template #noRoutersTemplate>
                                <i style="color: red;" class="fas fa-times"></i>
                            </ng-template>
                        </ng-template>

                        <ng-template #hasDevicesColumn let-deviceUsers="deviceUsers">
                            <ng-container *ngIf="checkDevicesOfDeviceUsers(deviceUsers); else noDevicesTemplate">
                                <i style="color: green;" class="fas fa-check"></i>
                            </ng-container>
                            <ng-template #noDevicesTemplate>
                                <i style="color: red;" class="fas fa-times"></i>
                            </ng-template>
                        </ng-template>

                        <ng-template #hasDataColumn let-turnOver="turnOver">
                          <ng-containter *ngIf="turnOver?.length > 0; else noDataTemplate">
                            <i style="color: green;" class="fas fa-check"></i>
                          </ng-containter>
                          <ng-template #noDataTemplate>
                            <i style="color: red" class="fas fa-times"></i>
                          </ng-template>
                        </ng-template>

                        <ng-template #isPaidColumn let-id="id" let-isPaid="isPaid">
                          <ng-container *ngIf="isPaid || getEventPaid(id); else notPaidTemplate">
                            <i style="color: green;" class="fas fa-check"></i>
                          </ng-container>
                          <ng-template #notPaidTemplate>
                            <button class="btn btn-primary btn-sm" (click)="updateEventPaidStatus(id, true)">Invoice</button>
                          </ng-template>
                        </ng-template>

                        <ng-template #actionsColumn let-id="id" let-eventName="eventName" let-turnOver="turnOver">
                            <a class="btn btn-primary btn-sm" href="events/details/{{id}}"><i
                                    class="fa fa-search-plus"></i></a>
                            <button class="btn btn-danger btn-sm" (click)="onDeleteButtonClick(id, deleteModal, eventName)">
                              <i class="fa fa-trash"></i>
                            </button>
                            @if (turnOver?.length > 0) {
                              <button class="btn btn-success btn-sm" (click)="onExcelExportClick(id)">
                                <i class="fa fa-file-excel"></i>
                              </button>
                            }
                        </ng-template>

                        <ng-template #deleteModal let-modal let-eventName="eventName">
                          <div class="modal-header" style="display: block">
                            <div style="font-size: xx-large; justify-self: center">Hard Delete Event</div>
                          </div>
                          <div class="modal-body" style="text-align: center;">
                            <div style="font-size: large">Are you sure you want to delete the following event?</div>
                            <div style="font-size: large; font-weight: 700">{{deleteEventName}}</div>
                            <div style="color: red; font-size: large; font-weight: 700">This action cannot be undone</div>
                            <div style="font-size: large; font-weight: 700">Insert PIN to confirm</div>
                            <input type="password" [(ngModel)]="deletePin">
                            <div style="color: red;" *ngIf="wrongPasswordError">PIN is not correct</div>
                          </div>
                          <div class="modal-footer" style="justify-content: space-around">
                            <button type="button" class="btn btn-outline-secondary"
                              (click)="modal.dismiss('cancel click')">Cancel</button>
                            <button type="button" class="btn btn-danger"
                              (click)="onDeleteConfirm()">Confirm</button>
                          </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
